// extracted by mini-css-extract-plugin
var _1 = "Oz5W8";
var _2 = "TSYKp";
var _3 = "FZzEY";
var _4 = "WKEV9";
var _5 = "UUFSP";
var _6 = "XSB10";
export { _1 as "close-button", _2 as "footer", _3 as "sidebar", _4 as "sidebar--no-close-button", _5 as "sidebar--wider", _6 as "sidebar--widest" }
